import CreateOrder from '../../../Components/Order/CreateOrder';

const NewOrder = () => {
  return (
    <div>
      <CreateOrder />
      {/* Additional NewOrder-specific UI */}
    </div>
  );
};

export default NewOrder;
